import SelectTeam from './src/main';

/* istanbul ignore next */
SelectTeam.install = function(Vue) {
  Vue.component(SelectTeam.name, SelectTeam);
};

export default SelectTeam;
